<template>
  <div class="buylist">
    <GlobTopNav title="购买记录" :rightHidden="false"></GlobTopNav>
    <div class="buylist-bg"></div>

    <div class="buylist-cont">
      <div class="headerbox">
        <!-- <top-nav ref="TopNav"></top-nav>
      <van-nav-bar title="购买记录" @click-right="onClickRight">
        <van-icon slot="left" class="iconfont icon-zuojiantou" style="font-size: .25rem" @click="goBack"></van-icon>
        <van-icon slot="right" class="iconfont icon-zhankai"></van-icon>
      </van-nav-bar> -->

        <div>
          <div class="van-cell van-hairline">
            <div class="van-cell__title">
              <span class="van-cell-text ft14">{{ unit }}变动</span>
            </div>
            <div class="van-cell__value"><span class="ft14">支付金额</span></div>
          </div>
        </div>
      </div>

      <div class="van-content">
        <div class="nodata text-cent" v-if="finished && datas == ''">
          <img src="./../../../assets/img/dd-null.png" />
          <span class="text">暂无记录~</span>
        </div>
        <div class="list">
          <div v-for="(items, index) in datas" :key="index" class="van-cell van-hairline">
            <div class="van-cell__title">
              <span class="van-cell-text">+{{ items.point }}{{ unit }}</span>
              <div class="van-cell__label">{{ time(items.add_time) }}</div>
            </div>
            <div class="van-cell__value">
              <span class="theme-col">￥{{ items.money }}</span>
            </div>
          </div>
        </div>
        <div v-if="!loading && finished && datas != ''" class="nomore">没有更多了~</div>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from "@/components/topnav";
export default {
  name: "Pointslist",
  components: { TopNav },
  computed: {
    unit: function() {
      return this.$store.state.unitinfo.name;
    }
  },
  data() {
    return {
      datas: [],
      page: 0,
      active: 0,
      type: 0,
      finished: false,
      loading: false
    };
  },
  methods: {
    goBack: function() {
      history.back(-1);
    },
    time: function(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s;
      if (date.getSeconds() < 10) {
        s = "0" + date.getSeconds();
      } else {
        s = date.getSeconds();
      }
      return Y + M + D + h + m + s;
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay();
    },
    vantabPlay(index) {
      this.datas = [];
      this.type = index;
      this.page = 0;
      if (this.finished) {
        this.finished = false;
      } else {
        this.loading = true;
        this.getDatas();
      }
    },
    getDatas: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      var _this = this;
      //        setTimeout(() => {
      this.$api.post(
        "user/wechat/buylist",
        { id_example: mallid, token_user: isUser },
        res => {
          if (res.data.code == "100") {
            if (res.data.data.length == 0) {
              _this.finished = true;
              _this.loading = false;
            } else {
              for (let i = 0; i < res.data.data.length; i++) {
                _this.datas.push(res.data.data[i]);
              }
              _this.loading = false;
            }
          } else {
            if (res.data.message == "token验证失败") {
              this.$dialog
                .confirm({
                  title: "提示 ",
                  message: "您还未登录是否去登录？"
                })
                .then(() => {
                  this.$router.push({ name: "NoteLogin" });
                })
                .catch(() => {});
            } else {
              this.$toast(res.data.message);
            }
          }
        }
      );
      //        },50)
    }
  },
  mounted() {
    this.getDatas();
  }
};
</script>

<style lang="less">
.buylist {
  .buylist-bg {
    width: 100%;
    height: 3.3rem;
    background: linear-gradient(133deg, #ffffff 0%, #f3e1d0 100%);
    position: absolute;
    top: 0;
  }

  .buylist-cont {
    background: #ffffff;
    border-radius: 0.24rem;
    margin-top: 0.8rem;
    width: calc(100% - 0.4rem);
    margin: 0.8rem auto 0 auto;
    overflow: hidden;
    position: relative;

    .headerbox {
      width: 100%;
      .van-cell__title {
        font-size: 0.26rem;
        font-weight: bold;
        color: #262626;
        line-height: 0.36rem;
      }
      .van-cell__value {
        font-size: 0.26rem;
        font-weight: 400;
        color: #262626;
        line-height: 0.36rem;
      }
    }

    .van-content {
      padding-bottom: 0;
      height: 75vh;
      background: #fff;
      position: relative;
      z-index: 2;
      .list {
        .van-cell::after {
          border-bottom: 0rem solid #ebedf0 !important;
        }
        .van-cell__title {
          .van-cell-text {
            font-size: 0.28rem;
            font-weight: 400;
            color: rgba(38, 38, 38, 0.8);
            line-height: 0.48rem;
          }
          .van-cell__label {
            font-size: 0.24rem;
            font-weight: 400;
            color: #929292;
            line-height: 0.42rem;
          }
        }
      }
      .van-cell {
        border-bottom: 0.01rem solid #f2f2f2;
      }
      .van-cell__value {
        font-size: 0.28rem;
        font-weight: 400;
        color: #fe5c42;
        line-height: 0.4rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/buypoints/detail.vue